import { FileChunk } from "./types";

export const splitFileIntoChunks = (file: Blob, chunkSizeBytes: number): FileChunk[] => {
  const chunks = [];

  for (let start = 0; start < file.size; start += chunkSizeBytes) {
    const end = Math.min(start + chunkSizeBytes, file.size);
    chunks.push({
      start,
      end,
      blob: file.slice(start, end),
    });
  }

  return chunks;
};
